import type { PlayerSaveSection } from "@/cloud/player-save-docs";

const TOAST_ID = "player-cloud-save-toast";
const HIDE_MS = 12_000;

const SECTION_LABEL_TH: Record<PlayerSaveSection, string> = {
  character: "ตัวละคร",
  gameState: "ความคืบหน้า",
  home: "บ้าน/กระเป๋า",
  skills: "สกิล",
};

function ensureToastEl(): HTMLElement {
  let el = document.getElementById(TOAST_ID);
  if (el) return el;
  el = document.createElement("div");
  el.id = TOAST_ID;
  el.className = "player-cloud-save-toast";
  el.setAttribute("role", "alert");
  el.hidden = true;
  document.body.appendChild(el);
  return el;
}

let hideTimer: ReturnType<typeof setTimeout> | null = null;

export function showPlayerCloudSaveToast(message: string): void {
  const el = ensureToastEl();
  el.textContent = message;
  el.hidden = false;
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    el.hidden = true;
    hideTimer = null;
  }, HIDE_MS);
}

export function notifyPlayerCloudSaveFailures(
  failed: PlayerSaveSection[],
  detail?: string,
): void {
  if (failed.length === 0) return;
  const names = failed.map((s) => SECTION_LABEL_TH[s]).join(", ");
  const extra = detail ? ` (${detail})` : "";
  showPlayerCloudSaveToast(
    `บันทึกคลาวด์ไม่สำเร็จ: ${names}${extra} — ข้อมูลอาจไม่ขึ้นเครื่องอื่น ลองเล่นต่อหรือเช็คเน็ต`,
  );
}

export function formatFirestoreSaveError(err: unknown): string {
  if (err && typeof err === "object" && "code" in err) {
    const code = String((err as { code: unknown }).code);
    if (code === "permission-denied") return "ไม่มีสิทธิ์เขียน";
    if (code === "resource-exhausted") return "ข้อมูลใหญ่เกินไป";
  }
  if (err instanceof Error && err.message) {
    if (/longer than \d+ bytes/i.test(err.message)) return "ข้อมูลใหญ่เกินไป";
    if (/invalid nested entity/i.test(err.message)) return "ข้อมูลใหญ่เกินไป";
    return err.message.slice(0, 120);
  }
  return "ไม่ทราบสาเหตุ";
}
